<template>
    <VueDatePicker v-model="modelValue" :locale="sl" :placeholder :class="{ 'date-picker-control-invalid': hasError }" :aria-invalid="hasError" :aria-describedby="errorId">
        <template v-for="(_, name) in $slots" #[name]="slotProps">
            <slot :name="name" v-bind="slotProps" />
        </template>
    </VueDatePicker>
</template>

<script setup>
import { VueDatePicker } from '@vuepic/vue-datepicker'
import { sl } from 'date-fns/locale'

const modelValue = defineModel('modelValue', {
    type: [String, Date, Array],
    default: ''
})

const props = defineProps({
    placeholder: {
        type: String,
        default: 'dd.mm.llll'
    },
    hasError: {
        type: Boolean,
        default: false
    },
    errorId: {
        type: String,
        default: null
    }
})
</script>
